import styles from "./ReportUIPrimitives.module.css";

// Reusable class name exports for check icons
export const summaryCheckClass = styles.summaryCheck;

export const Section = ({ title, children }) => (
  <div className={styles.section}>
    <h4 className={styles.sectionTitle}>{title}</h4>
    {children}
  </div>
);

export const Row = ({ label, value }) => (
  <div className={styles.row}>
    <span className={styles.rowLabel}>{label}</span>
    <span className={styles.rowValue}>{value}</span>
  </div>
);

export const Bullet = ({ children }) => (
  <div className={styles.bullet}>
    <span className={styles.bulletDot}>•</span>
    <span>{children}</span>
  </div>
);

export const Pill = ({ text, color }) => (
  <span
    className={styles.pill}
    style={color ? { backgroundColor: color } : undefined}
  >
    {text}
  </span>
);

export const KeyValueList = ({ obj = {} }) => {
  const entries = Object.entries(obj || {});
  if (!entries.length) return null;
  return (
    <div className={styles.kvList}>
      {entries.map(([k, v]) => (
        <Row key={k} label={toTitle(k)} value={formatValue(v)} />
      ))}
    </div>
  );
};

export const Swatch = ({ hex, name }) => (
  <div className={styles.swatch}>
    <div
      className={styles.swatchColor}
      style={{ backgroundColor: hex || "#ccc" }}
    />
    <span className={styles.swatchName}>{name || hex || "—"}</span>
  </div>
);

export const StatCard = ({ label, value, accent }) => (
  <div
    className={styles.statCard}
    style={accent ? { borderColor: accent } : undefined}
  >
    <span className={styles.statLabel}>{label}</span>
    <span className={styles.statValue}>{value}</span>
  </div>
);

export const HeroCard = ({ title, subtitle, children, badge }) => (
  <div className={styles.heroCard}>
    <div className={styles.heroHeader}>
      <h3 className={styles.heroTitle}>{title}</h3>
      {badge && <span className={styles.heroBadge}>{badge}</span>}
    </div>
    {subtitle && <p className={styles.heroSubtitle}>{subtitle}</p>}
    {children}
  </div>
);

// Utility functions
export const toTitle = (s = "") =>
  s.replace(/_/g, " ").replace(/\b\w/g, (m) => m.toUpperCase());

export const formatValue = (v) => {
  if (v == null) return "—";
  if (Array.isArray(v)) return v.length ? `${v.length} items` : "—";
  if (typeof v === "object") return "See details";
  return String(v);
};

export const secondsToMin = (sec) => {
  if (sec == null) return "—";
  const m = Math.floor(sec / 60);
  const s = Math.round(sec % 60);
  return `${m}m ${s}s`;
};

export const pct = (val) => {
  if (val == null) return "—";
  const num = typeof val === "number" ? val : parseFloat(val);
  if (isNaN(num)) return "—";
  return num < 1 ? `${(num * 100).toFixed(1)}%` : `${num.toFixed(1)}%`;
};

export const money = (val, currency = "USD") => {
  if (val == null) return "—";
  const num = typeof val === "number" ? val : parseFloat(val);
  if (isNaN(num)) return "—";
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(num);
};

export const fmtNumber = (value) => {
  if (value === null || value === undefined) return "—";
  if (typeof value === "number") return value.toLocaleString();
  return String(value);
};
